export default __webpack_public_path__ + "static/media/8.3e8b2672.jpg";